import { Link } from "react-router-dom";
import SiteLayout from "@/components/feature/SiteLayout";
import SectionHeading from "@/components/base/SectionHeading";
import HeroCarousel from "@/pages/home/components/HeroCarousel";
import CategoryGrid from "@/pages/home/components/CategoryGrid";
import PhotobookRow from "@/pages/home/components/PhotobookRow";
import NewsPreview from "@/pages/home/components/NewsPreview";
import SiteIntro from "@/pages/home/components/SiteIntro";

export default function Home() {
  return (
    <SiteLayout>
      <HeroCarousel />

      <section className="w-full px-4 py-12 md:px-6 md:py-16">
        <SectionHeading
          eyebrow="分类浏览"
          title="图片分类快捷入口"
          description="按风格快速定位你喜欢的图片类型，找到属于你的视觉偏好。"
          action={
            <Link
              to="/gallery"
              className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-4 py-2 text-sm font-medium text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-600"
            >
              进入图库
              <i className="ri-arrow-right-line"></i>
            </Link>
          }
        />
        <CategoryGrid />
      </section>

      <section className="w-full bg-background-100 px-4 py-12 md:px-6 md:py-16">
        <SectionHeading
          eyebrow="编辑推荐"
          title="最新写真推荐"
          description="精选摄影师最新发布的写真专辑，每一组都值得慢慢欣赏。"
          action={
            <Link
              to="/photobooks"
              className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-4 py-2 text-sm font-medium text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-600"
            >
              全部写真
              <i className="ri-arrow-right-line"></i>
            </Link>
          }
        />
        <PhotobookRow />
      </section>

      <section className="w-full px-4 py-12 md:px-6 md:py-16">
        <SectionHeading
          eyebrow="娱乐动态"
          title="最新娱乐资讯"
          description="关注人像摄影圈的最新新闻、摄影师专访与线下活动预告。"
          action={
            <Link
              to="/news"
              className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-4 py-2 text-sm font-medium text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-600"
            >
              更多资讯
              <i className="ri-arrow-right-line"></i>
            </Link>
          }
        />
        <NewsPreview />
      </section>

      <section className="w-full px-4 pb-4 md:px-6">
        <SiteIntro />
      </section>
    </SiteLayout>
  );
}